import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import useFreeBundles from "../../../common/hooks/useFreeBundles";

import {
 BRAND_TAGLINE,
 BRAND_SLOGAN,
 BRAND_COLOR_GRADIENT_ONE,
 BRAND_COLOR_GRADIENT_TWO,
} from "../../../common/constants";

import heroImage from "../../../assets/hero-speaking.png";
import "./heroSection.css";

const HeroSection = () => {
 const navigate = useNavigate();
 const { bundles } = useFreeBundles();

 const totalSessions = bundles.reduce((sum, b) => sum + b.sessions, 0);
 const badgeText = totalSessions > 0
 ? `🎁 Get ${totalSessions} Free Sessions — Start Speaking Today!`
 : "🎁 Start Speaking Today — Free Sessions Included!";

 return (
  <section
   className="hero-section"
   style={{
    background: `linear-gradient(135deg, ${BRAND_COLOR_GRADIENT_ONE} 0%, ${BRAND_COLOR_GRADIENT_TWO} 100%)`,
   }}
  >
   <div className="hero-container">

    {/* LEFT */}
    <motion.div
     className="hero-left"
     initial={{ opacity: 0, x: -40 }}
     animate={{ opacity: 1, x: 0 }}
     transition={{ duration: 0.7 }}
    >
     {/* FREE SESSIONS BADGE */}
     <motion.div
      className="hero-badge"
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2 }}
     >
      {badgeText}
     </motion.div>

     <h1 className="hero-title">{BRAND_TAGLINE}</h1>
     <p className="hero-slogan">{BRAND_SLOGAN}</p>
     <p className="hero-subtitle">Build confidence and express yourself freely in real conversations.</p>

     {/* CTA */}
     <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4 }}
      className="hero-cta-group"
     >
      <button
       className="hero-cta-btn"
       onClick={() => navigate("/register")}
       onMouseEnter={e => {
        e.currentTarget.style.background = "#046f77";
        e.currentTarget.style.color = "#ffffff";
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 12px 32px rgba(0,0,0,0.28)";
       }}
       onMouseLeave={e => {
        e.currentTarget.style.background = "#ffffff";
        e.currentTarget.style.color = "#046f77";
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.18)";
       }}
      >
       Start for Free <FaArrowRight size={13} />
      </button>
      <button
       className="hero-demo-btn"
       onClick={() => navigate("/free-demo")}
      >
       <span>🎓 Book a Free Demo</span>
      </button>
     </motion.div>
    </motion.div>

    {/* RIGHT IMAGE */}
    <motion.div
     className="hero-image-wrapper"
     initial={{ opacity: 0, x: 40 }}
     animate={{ opacity: 1, x: 0 }}
     transition={{ duration: 0.7 }}
    >
     <img
      src={heroImage}
      alt="Speak confidently online"
      className="hero-image"
     />
    </motion.div>
   </div>
  </section>
 );
};

export default HeroSection;
